import { PRODUCT_NAME } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Button, Dialog, DialogContent, Icon, toast } from "@sagot/ui";
import { useErrorMessage } from "../../../../lib/api-errors";
import { useZohoMutations } from "../use-zoho";
import { ZOHO_I18N } from "./zoho-card-parts";

interface ZohoDisconnectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Confirms before Sagot stops sending leads and revokes its access in Zoho (leads already in Zoho stay). */
export function ZohoDisconnectDialog({ open, onOpenChange }: ZohoDisconnectDialogProps) {
  const { t } = useTranslation();
  const message = useErrorMessage();
  const { disconnect } = useZohoMutations();
  const confirm = () => {
    disconnect.mutate(undefined, {
      onSuccess: () => {
        toast.info(t(`${ZOHO_I18N}.disconnect.done`));
        onOpenChange(false);
      },
      onError: (error) => { toast.error(message(error)); },
    });
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        title={t(`${ZOHO_I18N}.disconnect.title`)}
        description={t(`${ZOHO_I18N}.disconnect.body`, { product: PRODUCT_NAME })}
        closeLabel={t("common.close")}
        className="max-w-md"
        footer={
          <>
            <Button variant="ghost" onClick={() => { onOpenChange(false); }}>{t("common.cancel")}</Button>
            <Button variant="danger" loading={disconnect.isPending} onClick={confirm}>
              <Icon name="x-circle" />
              {t(`${ZOHO_I18N}.disconnect.confirm`)}
            </Button>
          </>
        }
      />
    </Dialog>
  );
}
